<div [id]="getId()" class="modal" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button class="modal-close-button" data-bs-dismiss="modal" title="Schließen" type="button"></button>
                @if (urlData && urlData.type === 'iFrame') {
                    <h4 class="modal-title">{{ modalAble.title }}</h4>
                }
            </div>
            <div class="modal-body">
                @if (!urlData) {
                    <app-loading-indicator></app-loading-indicator>
                }
                @if (urlData) {
                    @if (!imageClicked && urlData.type === 'iFrame') {
                        <div (tap)="showVideo()" class="preview-container">
                            <img (tap)="showVideo()" [attr.src]="'icon-video.png' | asset" alt="Play" class="play-button"
                                 height="60px" width="60px"/>
                            @if (urlData.image) {
                                <img (tap)="showVideo()" [attr.src]="urlData.image" alt="Video Vorschaubild"/>
                            }
                        </div>
                    }
                    @if (imageClicked && urlData.type === 'iFrame') {
                        <iframe [attr.alt]="'Video'"
                                [attr.src]="urlData.url" allowfullscreen class="iframe" frameborder="0">
                        </iframe>
                    }
                    @if (urlData.type === 'custom') {
                        <app-video [source]="urlData.url" [subtitles]="modalAble.subtitles" [title]="modalAble.title"/>
                    }
                }
            </div>
        </div>
    </div>
</div>
